export default "__VITE_ASSET__jZ2s_13w__"